<template>
  <div class="hire-rate-input">
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <input-currency ref="rate" v-model="rateObject" :disabled="disabled" :currency="currency" />
    <input :value="modelValue" name="rate" type="hidden" />
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  props: {
    initialValue: { type: [String, Number], default: 0 },
    currency: { type: String, default: 'DKK' },
    modelValue: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  computed: {
    rateObject: {
      get() {
        const currentVal = Number(this.modelValue)
        return {
          integer: currentVal.toFixed(2).slice(0, -3),
          fraction: currentVal ? currentVal.toFixed(2).slice(-2) : 0,
        }
      },
      set(val) {
        const value = Number(`${val.integer}.${val.fraction}`)
        this.$emit('update:modelValue', value)
      },
    },
  },
  mounted() {
    this.$emit('update:modelValue', this.initialValue)
  },
  methods: {
    focus() {
      nextTick(() => this.$refs.rate.focus?.())
    },
  },
}
</script>
